import { IAddQuestionnaireAnswers } from '../interfaces/Questionnaire/IAddQuestionnaireAnswers';
import {
  IQuestionnairePage,
  IQuestionnaireQuestion,
} from '../interfaces/Questionnaire/IQuestionnaire';

type QuestionnaireDataMap = IAddQuestionnaireAnswers['questionnaireData'];
type RawQuestionnaireValues = Record<string, unknown>;

export function buildDepartmentalQuestionnairePayload(
  questionnaireTemplateId: number,
  pages: IQuestionnairePage[],
  rawValues: RawQuestionnaireValues,
): IAddQuestionnaireAnswers {
  return {
    questionnaireTemplateId,
    questionnaireData: buildDepartmentalQuestionnaireData(pages, rawValues),
  };
}

export function buildDepartmentalQuestionnaireData(
  pages: IQuestionnairePage[],
  rawValues: RawQuestionnaireValues,
): QuestionnaireDataMap {
  const questionnaireData: QuestionnaireDataMap = {};

  pages.forEach((page: IQuestionnairePage) => {
    page.elements.forEach((element: IQuestionnaireQuestion) => {
      const serializedValue = serializeDepartmentalAnswer(
        rawValues[element.name as string],
      );

      if (serializedValue !== null) {
        questionnaireData[element.id] = serializedValue;
      }
    });
  });

  return questionnaireData;
}

function serializeDepartmentalAnswer(value: unknown): string | null {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value === 'boolean') {
    return value ? 'true' : 'false';
  }

  if (Array.isArray(value)) {
    const serializedItems = value
      .map((item: unknown) => serializeArrayItem(item))
      .filter((item: string | null): item is string => item !== null);

    return serializedItems.length > 0 ? serializedItems.join(',') : null;
  }

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value.toString() : null;
  }

  if (typeof value === 'string') {
    return value.trim() === '' ? null : value;
  }

  return String(value);
}

function serializeArrayItem(value: unknown): string | null {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value === 'string') {
    return value.trim() === '' ? null : value;
  }

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value.toString() : null;
  }

  if (typeof value === 'boolean') {
    return value ? 'true' : 'false';
  }

  return String(value);
}
